"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var forAllImagesInElement_1 = require("./functions/forAllImagesInElement");
exports.forAllImagesInElement = forAllImagesInElement_1.forAllImagesInElement;
var forAnimationFrame_1 = require("./functions/forAnimationFrame");
exports.forAnimationFrame = forAnimationFrame_1.forAnimationFrame;
var forImmediate_1 = require("./functions/forImmediate");
exports.forImmediate = forImmediate_1.forImmediate;
var forTime_1 = require("./functions/forTime");
exports.forTime = forTime_1.forTime;
var forValueDefined_1 = require("./functions/forValueDefined");
exports.forValueDefined = forValueDefined_1.forValueDefined;
// TODO: forever
